import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';

const MultipleChoice = ({ value, onChange, id, isReadOnly = false }) => {
  const companyInfo = useSelector(state => state.auth.companyInfo);
  const mainColor = companyInfo?.mainColor || '#3D6FEE';
  const useStyles = makeStyles(() => ({
    checkbox: {
      '& input:checked ~ .MuiSvgIcon-root': {
        color: mainColor,
      },
      '& input:checked[disabled] ~ .MuiSvgIcon-root': {
        color: 'rgba(0, 0, 100, 0.2)',
      },
    },
  }));
  const classes = useStyles();
  const { t } = useTranslation('common');

  const handleChange = event => {
    if (isReadOnly) {
      return;
    }
    // Use event.currentTarget.checked instead of !value[...] to get the actual new state
    // Always include both fields to ensure both are sent to the backend
    const visibilityResult = {
      isVisibleForStudent: value?.isVisibleForStudent ?? false,
      isVisibleForTrainer: value?.isVisibleForTrainer ?? false,
      [event.currentTarget.value]: event.currentTarget.checked,
    };
    delete visibilityResult.id;
    if (visibilityResult.type) {
      delete visibilityResult.type;
    }
    delete visibilityResult.isDisabled;
    onChange(id, visibilityResult, event.currentTarget.dataset.type);
  };

  const isDisabled = isReadOnly || (value && value.isDisabled);

  return (
    <FormControl component="fieldset">
      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox
              checked={value && value.isVisibleForStudent}
              onChange={handleChange}
              value="isVisibleForStudent"
              className={classes.checkbox}
              inputProps={{ 'data-type': value && value.type }}
              disabled={isDisabled}
            />
          }
          label={t('formLabels.student')}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={value && value.isVisibleForTrainer}
              onChange={handleChange}
              value="isVisibleForTrainer"
              className={classes.checkbox}
              inputProps={{ 'data-type': value && value.type }}
              disabled={isDisabled}
            />
          }
          label={t('formLabels.trainer')}
        />
      </FormGroup>
    </FormControl>
  );
};

MultipleChoice.defaultProps = {
  onChange: () => {},
  value: undefined,
  id: undefined,
};

MultipleChoice.propTypes = {
  value: PropTypes.shape({
    isVisibleForTrainer: PropTypes.bool,
    isVisibleForStudent: PropTypes.bool,
    isDisabled: PropTypes.bool,
    type: PropTypes.string,
  }),
  onChange: PropTypes.func,
  id: PropTypes.number,
  isReadOnly: PropTypes.bool,
};

export default MultipleChoice;
